export default "__VITE_ASSET__CF8cQzoB__"